import { render } from "./Loading.vue?vue&type=template&id=efe9d588&ts=true"
import script from "./Loading.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loading.vue?vue&type=script&setup=true&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=efe9d588&lang=scss"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "efe9d588"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('efe9d588', __exports__)) {
    console.log('reload')
    api.reload('efe9d588', __exports__)
  }
  
  module.hot.accept("./Loading.vue?vue&type=template&id=efe9d588&ts=true", () => {
    console.log('re-render')
    api.rerender('efe9d588', render)
  })

}


export default __exports__